module.exports = "/next-static/_next/static/images/multiLayout-9b463d5a55276c8a8f0872b305bc8ec3.png";